// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export default function ResText({ success, msg }) {
    if (success) {
        return <p className="font-bold text-mint">{msg}</p>
    } else {
        return <p className="font-bold text-light-coral">{msg}</p>
    }
}
